module.exports = __webpack_public_path__ + "img/task.18b1fdc3.svg";